module.exports = __webpack_public_path__ + "img/go_left.6088a8cb.svg";